import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import TagManagerService from 'services/TagManager';

let actions = [];
let aux = true;

const Specification = (props) => {
    const [clicked, setClicked] = useState(false);
    const [specificationState, setSpecifications] = useState([]);
    const { items, id } = props;

    useEffect(() => {
        items.map(item => {
            item.checked = item.active
        })

        actions.push(PubSub.register('close_specification', close));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const close = (payload) => {
        if ((payload.value && payload.value.id !== id) || !(payload && payload.value)) {
            setClicked(false);
        }
    }

    const click = () => {
        setClicked(prevState => !prevState);
        PubSub.dispatch('close_categories');
        PubSub.dispatch('close_brands');
        PubSub.dispatch('close_specification',{id});
    }

    const change = (event, item, identifier) => {
        if (event && event.target.checked) {
            if (!item || !identifier) return false;
            item.id = identifier;
        }

        const _specificationSelect = specificationState.map(specification => {
            if(specification.Link && specification.Link === item.Link){
                specification.checked = event && event.target.checked;
                const title_crumbs = specification.Link.charAt(0).toUpperCase() + specification.Link.slice(1).replace(/-/g, " ");
                const categoryProduct = title_crumbs.split('/')[1];

                TagManagerService.menu(categoryProduct, specification.Name, 'Uso');
            }

            return specification;
        });
        setSpecifications([..._specificationSelect]);
        PubSub.dispatch('filter_specificationSelected', { specifications: _specificationSelect});
    }

    useEffect(() => {
        setSpecifications(items);
    }, [items]);

    useEffect(() => {
        if(aux && specificationState.length){
            aux = false;
            PubSub.dispatch('filter_specificationSelected', { specifications: items.filter(item => item.active)});
        }
    },[specificationState])

    const title = props.title;
    const qty = items.filter(item => item.active).length;

    return (
        <div className={'catalog-aside-nav' + (clicked ? ' active' : '')}>
            <div className={"catalog-aside-nav-title-wrap" + (clicked ? ' active ' : '')} onClick={click}>
                <h4 className="catalog-aside-nav-title">
                    {title}
                    {!!qty && <span className="catalog-aside-nav-count">{qty}</span>}
                </h4>
                <i className={"catalog-aside-view-more" + (clicked ? ' active ' : '')}>{clicked ? '-' : '+'}</i>
            </div>
            <ul className={'catalog-aside-nav-list specification' + (clicked ? ' active' : '')}>
                {items.map((item, i) =>
                    <li className="catalog-aside-nav-item" key={i}>
                        <label>
                            <input type="checkbox" value={item.Name} checked={item.checked || false} onChange={(event) => change(event, item, id)} />
                            <i className={'catalog-aside-nav-checkbox'}></i>
                            {item.Name}
                        </label>
                    </li>)}
            </ul>
        </div>
    )
}

Specification.propTypes = {
    items: PropTypes.array,
    title: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filter: PropTypes.object
};

export default Specification;
